import ThemeOptions from "./ThemeOptions";
import { combineReducers } from "redux";
import auth from "./auth";
import message from "./message";
import backdrops from "./backdrops";
import user from "./users";
import product from "./products"
import order from "./orders"
import category from "./categories"
import refund from "./refunds"
import reward from "./rewards"
import referral from "./referral"
import cart from "./carts"
import contact from "./contacts"
import chat from "./chat"
import permissions from "./permissions";
const reducers = combineReducers({
  auth,
  permissions,
  message,
  backdrops,
  ThemeOptions,
  user,
  product,
  category,
  order,
  refund,
  reward,
  referral,
  cart,
  contact,
  chat
});

export default reducers;
